import StoreUtil from '@store/StoreUtil';
import { Dispatch } from 'vuex';
import UserService from '@core/services/user/UserService';
import AuthenticationError from '@errors/authentication/AuthenticationError';
import store from '@app/store';

export const SET_IS_ID_CARD_VERIFICATION_PENDING = 'SET_IS_ID_CARD_VERIFICATION_PENDING';
export const SET_IS_BALANCE_LOADING = 'SET_IS_BALANCE_LOADING';

export interface IAccountState {
    // this field servers only for idCardVerification modal upload <=> accountContainer communication
    // accountContainer must hide upload button after modal idCard upload finishes upload!
    // this is because Leapbit/CT does not have proper status for idCardVerification pending!
    isIdCardVerificationPending: boolean;
    isBalanceLoading: boolean;
}

function defaultState(): IAccountState {
    return {
        isIdCardVerificationPending: false,
        isBalanceLoading: false,
    };
}

export default {
    namespaced: true,

    state: defaultState(),

    mutations: {
        [SET_IS_ID_CARD_VERIFICATION_PENDING]: StoreUtil.createSimpleMutator('isIdCardVerificationPending'),
        [SET_IS_BALANCE_LOADING]: StoreUtil.createSimpleMutator('isBalanceLoading'),
    },

    getters: {
        isIdCardVerificationPending: StoreUtil.createSimpleGetter('isIdCardVerificationPending'),
        isBalanceLoading: StoreUtil.createSimpleGetter('isBalanceLoading'),
    },

    actions: {
        setIsIdCardVerificationPending: StoreUtil.createSimpleMutatorAction(SET_IS_ID_CARD_VERIFICATION_PENDING),
        setIsBalanceLoading: StoreUtil.createSimpleMutatorAction(SET_IS_BALANCE_LOADING),
        getBalance: StoreUtil.asyncErrorGuard(
            async (
                { dispatch }: { dispatch: Dispatch },
                options?: { showLoading: boolean }
            ) => {
                if (options && options.showLoading) {
                    dispatch('setIsBalanceLoading', true);
                }

                try {
                    const balance = await UserService.getInstance().getPlayerBalance();
                    dispatch(
                        'data/authentication/setUserData',
                        {
                            key: 'balance',
                            value: balance
                        },
                        { root: true }
                    );
                } catch (e) {
                    if (e instanceof AuthenticationError) {
                        store.dispatch('data/authentication/sessionExpired', null, { root: true });
                        return;
                    }

                    if (options && options.showLoading) {
                        dispatch('setIsBalanceLoading', false);
                    }
                    throw e;
                }

                if (options && options.showLoading) {
                    dispatch('setIsBalanceLoading', false);
                }
            }
        ),
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/user/account/accountIndex.ts